import React from "react";
import { Card, CardContent } from "@mui/material";
import MDBox from "shared/components/MDBox";
import MDTypography from "shared/components/MDTypography";

const PowerBIEmbed = () => {
  return (
    <MDBox py={-4}>
      <Card>
        <CardContent>
          <MDTypography variant="h6" gutterBottom>
            Tablero de Conciliaciones - Comercios
          </MDTypography>
          <div style={{ position: "relative", paddingTop: "56.25%" /* 16:9 ratio */ }}>
            <iframe
              title="Tablero de Conciliaciones Comercios"
              src="https://app.powerbi.com/view?r=eyJrIjoiMWE3ZTg4MjMtOTg2My00NjE1LTk1MWYtNzdlZjRjOTlkMzA2IiwidCI6ImY5MTdlZDFiLWI0MDMtNDljNS1iODBiLWJhYWUzY2UwMzc1YSJ9"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "95%",
                border: "none",
              }}
              frameBorder="0"
              allowFullScreen
            ></iframe>
          </div>
        </CardContent>
      </Card>
    </MDBox>
  );
};

export default PowerBIEmbed;
